(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techvu-hero-slider"] && !Shopify.designMode) return;
  try {
    
  class TechVuHeroSlider extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.slides = Array.from(this.querySelectorAll('[data-techvu-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-techvu-dot]'));
      this.previousButton = this.querySelector('[data-techvu-previous]');
      this.nextButton = this.querySelector('[data-techvu-next]');
      this.toggleButton = this.querySelector('[data-techvu-toggle]');
      this.pauseIcon = this.querySelector('[data-techvu-pause]');
      this.playIcon = this.querySelector('[data-techvu-play]');
      this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.delay = Number(this.dataset.autoplaySpeed) || 4000;
      this.userPaused = false;
      this.interactionPaused = false;
      this.touchStartX = 0;
      this.timer = null;

      this.previousButton?.addEventListener('click', () => this.show(this.currentIndex - 1, true));
      this.nextButton?.addEventListener('click', () => this.show(this.currentIndex + 1, true));
      this.toggleButton?.addEventListener('click', () => this.toggleAutoplay());
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.show(Number(dot.dataset.techvuDot), true));
      });

      this.addEventListener('mouseenter', () => this.pauseInteraction());
      this.addEventListener('mouseleave', () => this.resumeInteraction());
      this.addEventListener('focusin', () => this.pauseInteraction());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.resumeInteraction();
      });
      this.addEventListener('touchstart', (event) => {
        this.touchStartX = event.changedTouches[0]?.clientX || 0;
      }, { passive: true });
      this.addEventListener('touchend', (event) => {
        const endX = event.changedTouches[0]?.clientX || 0;
        const distance = endX - this.touchStartX;
        if (Math.abs(distance) > 50) {
          if (distance > 0) this.show(this.currentIndex - 1, true);
          else this.show(this.currentIndex + 1, true);
        }
      }, { passive: true });

      this.onBlockSelect = this.handleBlockSelect.bind(this);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      this.show(this.currentIndex, false);
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    show(index, restart) {
      if (this.slides.length === 0) return;
      this.currentIndex = (index + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.currentIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.dots.forEach((dot, dotIndex) => {
        dot.setAttribute('aria-current', dotIndex === this.currentIndex ? 'true' : 'false');
      });

      if (restart) this.startAutoplay();
    }

    startAutoplay() {
      this.stopAutoplay();
      if (!this.autoplayEnabled || this.userPaused || this.interactionPaused || this.slides.length < 2) return;
      this.timer = window.setInterval(() => this.show(this.currentIndex + 1, false), this.delay);
    }

    stopAutoplay() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    pauseInteraction() {
      this.interactionPaused = true;
      this.stopAutoplay();
    }

    resumeInteraction() {
      this.interactionPaused = false;
      this.startAutoplay();
    }

    toggleAutoplay() {
      this.userPaused = !this.userPaused;
      if (this.pauseIcon) this.pauseIcon.hidden = this.userPaused;
      if (this.playIcon) this.playIcon.hidden = !this.userPaused;
      if (this.toggleButton) {
        this.toggleButton.setAttribute(
          'aria-label',
          this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel
        );
      }
      this.startAutoplay();
    }

    handleBlockSelect(event) {
      const blockId = event.detail?.blockId;
      const slide = this.slides.find((item) => item.dataset.blockId === blockId);
      if (!slide) return;
      this.userPaused = true;
      this.show(Number(slide.dataset.slideIndex), false);
      this.stopAutoplay();
      if (this.pauseIcon) this.pauseIcon.hidden = true;
      if (this.playIcon) this.playIcon.hidden = false;
    }
  }

  if (!customElements.get('techvu-hero')) {
    customElements.define('techvu-hero', TechVuHeroSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
